import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function BoldIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 18V13H11C13.26 13 14.5 13.812 14.5 15.5C14.5 17.286 13.214 18 11 18H9.5ZM9.5 6H11C12.458 6 13.5 6.75 13.5 8.3C13.5 10.125 12.458 11 11 11H9.5V6ZM17.5 15.503C17.5 13.35 16.16 11.892 14.5 11.5V11.4C15.814 10.911 16.5 9.517 16.5 8C16.5 5.064 14.613 4 11.5 4H6.5V20H11.5C14.821 20 17.5 18.707 17.5 15.503Z",
    fill: "currentColor"
  }));
}